import { Component } from '@angular/core';

@Component({
  selector: 'app-shared-header-third-panel',
  templateUrl: './shared-header-third-panel.component.html',
  styleUrl: './shared-header-third-panel.component.scss',
  standalone: false,
})
export class SharedHeaderThirdPanelComponent {}
